import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchCustomerSegmentInfo = createAsyncThunk("fetchCustomerSegmentInfo", async (id) => {
	const response = await axiosHttp.get(`customer-segment/${id}`);
	return response.data.data;
});

const CustomerSegmentInfoSlice = createSlice({
	name: "CustomerSegmentInfoSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchCustomerSegmentInfo.pending, (state) => {
			state.isLoading = true;
		});
		builder.addCase(fetchCustomerSegmentInfo.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchCustomerSegmentInfo.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default CustomerSegmentInfoSlice.reducer;
